import React from 'react';

interface TooltipProps {
    text: string;
    position: { x: number; y: number };
    visible: boolean;
    marginTop?: number;
    marginLeft?: number;
    isPositionSet?: boolean;
}

const ToolTipComponent: React.FC<TooltipProps> = ({ text, position, visible, marginTop, marginLeft, isPositionSet }) => {
    if (!visible) return null;

    // Use nullish coalescing (??) for default values
    const topSpace = marginTop ?? 0;
    const leftSpace = marginLeft ?? 0;

    return (
        <div
            className="tooltip"
            style={{
                position: 'absolute',
                top: isPositionSet ? position.y + topSpace : topSpace,
                left: isPositionSet ? position.x + leftSpace : leftSpace,
            }}
        >
            {text}
        </div>
    );
};

export default ToolTipComponent;
